module.exports = __webpack_public_path__ + "img/8.ceea5259.jpg";